(function() {
  'use strict';

  if (window.__serviceHubInit) return;
  window.__serviceHubInit = true;

  document.addEventListener('DOMContentLoaded', function() {
    initStickyNav();
    initServiceFinder();
    initCategoryPills();
    initFaqAccordion();
    initFaqShowMore();
    initCardFlip();
    initQuoteModal();
  });

  /* ========================================
     Sticky Nav - scroll tracking & active tab
     ======================================== */
  function initStickyNav() {
    var nav = document.querySelector('[data-service-hub-nav]');
    if (!nav) return;

    var tabs = nav.querySelectorAll('[data-nav-tab]');
    var sections = document.querySelectorAll('[data-category-section]');

    if (!tabs.length || !sections.length) return;

    // Add stuck class on scroll
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        nav.classList.toggle('shub-nav--stuck', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    var hero = document.querySelector('[data-service-hub-hero]');
    if (hero) observer.observe(hero);

    // Track active section
    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.getAttribute('data-category-section');
          setActiveTab(id, tabs);
        }
      });
    }, {
      root: null,
      threshold: 0.3,
      rootMargin: '-100px 0px -50% 0px'
    });

    sections.forEach(function(section) {
      sectionObserver.observe(section);
    });

    // Tab clicks
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var targetId = tab.getAttribute('data-target');
        var target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function setActiveTab(id, tabs) {
    tabs.forEach(function(tab) {
      var isActive = tab.getAttribute('data-target') === id;
      tab.classList.toggle('shub-nav__tab--active', isActive);

      // Scroll active tab into view on mobile
      if (isActive) {
        var scroll = tab.closest('[data-nav-scroll]');
        if (scroll && window.innerWidth < 768) {
          var tabLeft = tab.offsetLeft;
          var scrollLeft = scroll.scrollLeft;
          var scrollWidth = scroll.offsetWidth;
          var tabWidth = tab.offsetWidth;

          if (tabLeft < scrollLeft || tabLeft + tabWidth > scrollLeft + scrollWidth) {
            scroll.scrollTo({
              left: tabLeft - (scrollWidth / 2) + (tabWidth / 2),
              behavior: 'smooth'
            });
          }
        }
      }
    });
  }

  /* ========================================
     Service Finder - dropdown jump-to-service
     ======================================== */
  function initServiceFinder() {
    var select = document.querySelector('[data-service-finder]');
    if (!select) return;

    select.addEventListener('change', function() {
      var serviceName = select.value;
      if (!serviceName) return;

      var selectedOption = select.options[select.selectedIndex];
      var sectionId = selectedOption.getAttribute('data-section');

      // First scroll to the category section
      if (sectionId) {
        var section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      // Find the matching card by title and expand it after scroll
      setTimeout(function() {
        var cards = document.querySelectorAll('[data-service-card]');
        cards.forEach(function(card) {
          var title = card.getAttribute('data-service-title') || '';
          if (title === serviceName) {
            // Scroll the card into view
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });

            // Flash highlight effect
            card.style.transition = 'box-shadow 0.3s ease, border-color 0.3s ease';
            card.style.boxShadow = '0 0 0 3px rgba(0, 168, 204, 0.4)';
            card.style.borderColor = '#00a8cc';

            // Auto-expand if not already expanded
            if (!card.classList.contains('shub-card--expanded')) {
              var expandBtn = card.querySelector('[data-card-expand]');
              if (expandBtn) {
                setTimeout(function() { expandBtn.click(); }, 400);
              }
            }

            // Remove highlight after a moment
            setTimeout(function() {
              card.style.boxShadow = '';
              card.style.borderColor = '';
            }, 2500);
          }
        });
      }, 600);

      // Reset dropdown after selection
      setTimeout(function() { select.value = ''; }, 1500);
    });
  }

  /* ========================================
     Category Pills - smooth scroll from hero
     ======================================== */
  function initCategoryPills() {
    var pills = document.querySelectorAll('[data-category-pill]');

    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var targetId = pill.getAttribute('data-target');
        var target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ========================================
     Card Expand/Collapse - More Info toggle
     ======================================== */
  function initCardFlip() {
    document.addEventListener('click', function(e) {
      var expandBtn = e.target.closest('[data-card-expand]');
      if (!expandBtn) return;

      e.preventDefault();
      var card = expandBtn.closest('.shub-card');
      if (!card) return;

      var isExpanded = card.classList.contains('shub-card--expanded');
      var detail = card.querySelector('[data-card-detail]');

      if (isExpanded) {
        card.classList.remove('shub-card--expanded');
        expandBtn.setAttribute('aria-expanded', 'false');
        if (detail) detail.setAttribute('aria-hidden', 'true');

        // Update button text
        var textNode = expandBtn.firstChild;
        if (textNode && textNode.nodeType === 3) {
          textNode.textContent = 'More Info ';
        }
      } else {
        card.classList.add('shub-card--expanded');
        expandBtn.setAttribute('aria-expanded', 'true');
        if (detail) detail.setAttribute('aria-hidden', 'false');

        // Update button text
        var textNode = expandBtn.firstChild;
        if (textNode && textNode.nodeType === 3) {
          textNode.textContent = 'Less Info ';
        }
      }
    });
  }

  /* ========================================
     Quote Modal + webhook submission
     ======================================== */
  function initQuoteModal() {
    var modal = document.querySelector('[data-quote-modal]');
    if (!modal) return;

    var form = modal.querySelector('[data-quote-form]');
    var serviceLabel = modal.querySelector('[data-quote-service-label]');
    var serviceInput = modal.querySelector('[data-quote-service-input]');
    var serviceInputAlt = modal.querySelector('[data-quote-service-input-alt]');
    var pageUrlInput = modal.querySelector('[data-quote-page-url]');
    var status = modal.querySelector('[data-quote-status]');
    var submitBtn = modal.querySelector('[data-quote-submit]');
    var transport = modal.querySelector('iframe[name="shub_quote_webhook_iframe"]');
    var firstInput = modal.querySelector('#shubQuoteName');
    if (!form || !serviceLabel || !serviceInput || !pageUrlInput || !status || !submitBtn) return;

    var activeService = '';
    var lastBodyOverflow = '';
    var submissionPending = false;

    function setStatus(message, state) {
      status.textContent = message || '';
      if (state) {
        status.setAttribute('data-state', state);
      } else {
        status.removeAttribute('data-state');
      }
    }

    function openModal(serviceName) {
      activeService = (serviceName || '').trim() || 'General Service Hub Enquiry';
      serviceLabel.textContent = activeService;
      serviceInput.value = activeService;
      if (serviceInputAlt) serviceInputAlt.value = activeService;
      pageUrlInput.value = window.location.href;
      setStatus('', '');
      submitBtn.disabled = false;

      modal.hidden = false;
      lastBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = lastBodyOverflow;
      form.reset();
      serviceInput.value = '';
      if (serviceInputAlt) serviceInputAlt.value = '';
      pageUrlInput.value = '';
      activeService = '';
      submissionPending = false;
      submitBtn.disabled = false;
      setStatus('', '');
    }

    function showSubmittedState() {
      if (!submissionPending) return;
      submissionPending = false;
      submitBtn.disabled = false;
      setStatus('Thanks. Your quote request has been sent and our team will contact you shortly.', 'success');
      form.reset();
      serviceInput.value = activeService;
      if (serviceInputAlt) serviceInputAlt.value = activeService;
      pageUrlInput.value = window.location.href;
    }

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-service-quote]');
      if (trigger) {
        e.preventDefault();
        var serviceName = trigger.getAttribute('data-service-name') || '';
        if (!serviceName) {
          var card = trigger.closest('[data-service-card]');
          if (card) serviceName = card.getAttribute('data-service-title') || '';
        }
        openModal(serviceName);
        return;
      }

      var closeTrigger = e.target.closest('[data-quote-modal-close]');
      if (closeTrigger && !modal.hidden) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    form.addEventListener('submit', function() {
      if (!activeService) {
        setStatus('Please select a service before submitting.', 'error');
        return;
      }

      serviceInput.value = activeService;
      if (serviceInputAlt) serviceInputAlt.value = activeService;
      pageUrlInput.value = window.location.href;
      setStatus('Sending your request...', '');
      submitBtn.disabled = true;
      submissionPending = true;

      window.setTimeout(function() {
        showSubmittedState();
      }, 2500);
    });

    if (transport) {
      transport.addEventListener('load', function() {
        showSubmittedState();
      });
    }
  }

  /* ========================================
     FAQ Accordion
     ======================================== */
  function initFaqAccordion() {
    var toggles = document.querySelectorAll('[data-faq-toggle]');

    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var item = toggle.closest('.shub-faq__item');
        var isOpen = item.classList.contains('shub-faq__item--open');

        // Close all others
        document.querySelectorAll('.shub-faq__item--open').forEach(function(openItem) {
          openItem.classList.remove('shub-faq__item--open');
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('shub-faq__item--open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ========================================
     FAQ Show More
     ======================================== */
  function initFaqShowMore() {
    var btn = document.querySelector('[data-faq-show-more]');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var hiddenItems = document.querySelectorAll('.shub-faq__item--hidden');
      hiddenItems.forEach(function(item) {
        item.classList.remove('shub-faq__item--hidden');
        item.classList.add('shub-faq__item--visible');
      });
      btn.classList.add('shub-faq__more-btn--hidden');
    });
  }

})();
